const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const TemplatePermissionActions = Reflux.createActions({
    addTemplatePermission: { children: ['completed', 'failed'] },
    deleteTemplatePermission: { children: ['completed', 'failed'] },
    getUserTemplatePermissions: { children: ['completed', 'failed'] },
    getProjectTemplatePermissions: { children: ['completed', 'failed'] }
});

TemplatePermissionActions.addTemplatePermission.listen(function(actionId, params) {
    const self = this;

    if (!params.templateId || !params.userId) {
        this.failed(actionId, new ForgeError({ message: 'Missing arguments' }));
    }

    ServerRequest.makeRequest((`/authoring/templates/${params.templateId}/permissions/user/${params.userId}`), 'PUT', JSON.stringify({}))
        .then(res => { self.completed(actionId, params.userId, res); })
        .catch(err => { self.failed(actionId, params.userId, err); });
});

TemplatePermissionActions.deleteTemplatePermission.listen(function(actionId, params) {
    const self = this;

    if (!params.templateId || !params.userId) {
        this.failed(actionId, new ForgeError({ message: 'Missing arguments' }));
    }

    ServerRequest.makeRequest((`/authoring/templates/${params.templateId}/permissions/user/${params.userId}`), 'DELETE', JSON.stringify({}))
        .then(res => { self.completed(actionId, params.userId, res); })
        .catch(err => { self.failed(actionId, params.userId, err); });
});

TemplatePermissionActions.getUserTemplatePermissions.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/templates/permissions/user/${params.userId}`, 'GET')
        .then(res => { self.completed(actionId, params.userId, res); })
        .catch(err => { self.failed(actionId, params.userId, err); });
});

TemplatePermissionActions.getProjectTemplatePermissions.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/templates/permissions/project/${params.projectId}`, 'GET')
        .then(res => { self.completed(actionId, params.channelId, res); })
        .catch(err => { self.failed(actionId, params.channelId, err); });
});

module.exports = TemplatePermissionActions;